import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-4 pb-28 pt-12 sm:px-6 sm:pb-32 sm:pt-16" data-id="element-235" data-mp="19j53j40hsmi0">
      <div className="mx-auto max-w-2xl text-center" data-id="element-236" data-mp="206rj9imgluta">
        <p className="font-display text-[22px] font-extrabold leading-tight text-white sm:text-3xl" data-id="element-237" data-mp="2f4jtbv98lr03">
          Percorso Malattia Renale™
        </p>
        <p className="mt-2 text-[12px] font-bold uppercase tracking-[0.16em] text-kidney-bright" data-id="element-238" data-mp="2a69xdifoumdf">
          Sistema di Decisione Clinica per Medici
        </p>
        <p className="mt-4 text-[13.5px] font-semibold text-white/70" data-id="element-239" data-mp="1hhl425kvjlc8">
          Diagnosi. Trattamento. Monitoraggio. Invio.
        </p>

        <div className="mx-auto mt-6 max-w-sm rounded-2xl bg-white/[0.06] px-4 py-4" data-id="element-240" data-mp="1w7ilm2oatcsg">
          <p className="text-[14px] text-white/75" data-id="element-241" data-mp="1reh5jrccv77a">Il tuo paziente ha un problema renale.</p>
          <p className="mt-1 text-[15px] font-bold text-white" data-id="element-242" data-mp="13omvfhjf7wqq">Ora hai un percorso.</p>
        </div>

        <p className="mt-8 text-[11.5px] leading-relaxed text-white/45" data-id="element-243" data-mp="ypiiqgxafgvn">
          Percorso Malattia Renale™ — Materiale educativo destinato ai professionisti
          sanitari. Non sostituisce il giudizio clinico individuale, il rapporto
          medico-paziente, le linee guida aggiornate, le informazioni ufficiali sui
          farmaci o un’appropriata consulenza specialistica.
        </p>
        <p className="mt-3 text-[11.5px] font-semibold text-white/40" data-id="element-244" data-mp="1s8fi5de13a64">
          © 2026 Dott.ssa Karito. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}